import React from 'react';
// @ts-ignore
const QRCodeReact = require('qrcode.react');

interface QRCodeProps {
  value: string;
  size?: number;
  className?: string;
}

export const QRCode: React.FC<QRCodeProps> = ({ value, size = 180, className = '' }) => {
  return (
    <div className={className} style={{ display: 'inline-block', background: '#fff', padding: 8, borderRadius: 12 }}>
      <QRCodeReact value={value} size={size} level="M" includeMargin={false} renderAs="svg" />
    </div>
  );
}; 